// Same agent bootstrap as features/pendo/utils/pendoScriptUtils, keyed to the assessments Pendo app
export function setupAssessmentsPendoScript(apiKey: string): Promise<string> {
  return new Promise((resolve, reject) => {
    (function (p: any, e: any, n: any, d: any, o?: any) {
      let w;
      let x;
      // eslint-disable-next-line no-param-reassign, no-multi-assign
      o = p[d] = p[d] || {};
      // eslint-disable-next-line no-param-reassign
      o.q = o.q || [];
      const v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          // eslint-disable-next-line no-param-reassign
          o[m] =
            o[m] ||
            function (args: any[]) {
              o.q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(args, 0)));
            };
        })(v[w]);
      const y = e.createElement(n);
      const z = e.getElementsByTagName(n)[0];
      y.async = !0;
      y.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
      z.parentNode.insertBefore(y, z);

      y.onload = () => resolve('Assessments Pendo script loaded successfully');
      y.onerror = () => reject(new Error('Failed to load Assessments Pendo script'));
    })(window, document, 'script', 'pendo');
  });
}
